import { Route as Router, Routes } from 'react-router-dom'
import Home from './pages/Home'
import {
    ForgotPassword,
    Login,
    Register,
    ResetPassword,
    TwoFAuthentication,
    GithubLogin,
    GoogleLogin,
} from 'pages/Auth'
import ApiKeys from 'pages/ApiKeys/ApiKeys'
import MainComponent from 'pages/MainComponent'
import ChangePassword from 'pages/ChangePassword'
import Account from 'pages/Account'
import { AuthContext } from 'contexts'
import { useContext, useEffect, useState } from 'react'
import { PublicRoute } from 'routes'
import UpdatePassword from 'pages/UpdatePassword'
import { ThemeProvider } from 'styled-components'
import { darkTheme, lightTheme } from 'styles/theme'
import DeleteConfirmationModal from 'modals/DeleteConfirmationModal'
import MainRouteLayout from 'routes/MainRouteLayout'
import RootLayout from 'routes/RootLayout'
import HomeRouteLayout from 'routes/HomeRouteLayout'
import SuccessPaymentModal from 'modals/SuccessPaymentModal'
import LoginModal from 'modals/LoginModal'
import {
    Subnets,
    CreateSubnetApiService,
    SubnetApiService,
    EditSubnetApiModal,
} from 'pages/Subnets'
import Billing from 'pages/Billing'
import CreateNewApp from 'pages/CreateNewApp'

import UpdateAppWrapper from 'pages/CreateNewApp/UpdateAppWrapper'
import ShowApiKeyModal from 'pages/ApiKeys/ShowApiKey/ShowApiKeyModal'
import CreateApiModal from 'pages/ApiKeys/CreateApiKey/CreateApiModal'
import EditApiModal from 'pages/ApiKeys/EditApiKey/EditApiModal'
import SubnetApiDetailsModal from 'pages/Subnets/panels/SubnetApiDetailsModal'
import { useAppModeContext } from 'context/AppModeContext'
import Admin from 'pages/Admin'
import AdminHome from 'pages/Admin/AdminHome'
import ExploreApis from 'pages/ExploreApis'
import Profile from 'pages/Profile'
import { InviteUsers } from 'pages/InviteUsers'
import ManageTeams from 'pages/ManageTeams'
import Chat from 'pages/Search/Chat'
import Browse from 'pages/Search/Browse'
import Logs from 'pages/Logs'
import PlaygroundPage from 'pages/Playground'
import ImagesModal from 'pages/Subnets/panels/Playground/components/History/ImagesModal'
import WelcomeLoader from 'components/Loader/WelcomeLoader'
import ToastProvider from 'providers/ToastProvider'
import EmailSentModal from 'pages/Auth/ForgotPassword/EmailSentModal'

const Route = () => {
    const { account_switch_loading } = useAppModeContext()
    const { user, loading } = useContext(AuthContext)
    const [theme, setTheme] = useState<string>(() => {
        const storedTheme = localStorage.getItem('theme')
        return storedTheme || 'dark'
    })

    useEffect(() => {
        const currentThemeName = localStorage.getItem('theme')

        if (currentThemeName && currentThemeName !== theme) {
            setTheme(currentThemeName)
        } else {
            localStorage.setItem('theme', theme)
        }
    }, [theme])

    const toggleTheme = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark'
        localStorage.setItem('theme', newTheme)
        setTheme(newTheme)
    }

    if (loading || account_switch_loading) return <WelcomeLoader />

    return (
        <ThemeProvider theme={theme === 'dark' ? darkTheme : lightTheme}>
            <ToastProvider>
                <Routes>
                    <>
                        <Router element={<RootLayout theme={{ theme, toggleTheme }} />}>
                            {user?.role === 'admin' ? (
                                <>
                                    <Router element={<HomeRouteLayout />}>
                                        <Router
                                            path='/'
                                            element={<AdminHome />}
                                            key={document.location.href}
                                        />
                                    </Router>
                                    <Router
                                        path='/admin'
                                        element={<Admin />}
                                        key={document.location.href}
                                    />
                                </>
                            ) : (
                                <>
                                    <Router element={<HomeRouteLayout />}>
                                        <Router
                                            path='/'
                                            element={<Home />}
                                            key={document.location.href}
                                        />
                                    </Router>

                                    <Router element={<MainRouteLayout />}>
                                        <Router
                                            path='change-password'
                                            element={<ChangePassword />}
                                            key={document.location.href}
                                        />
                                        <Router
                                            path='account'
                                            element={<Account />}
                                            key={document.location.href}
                                        />
                                    </Router>

                                    <Router
                                        path={'subnets'}
                                        element={<Subnets />}
                                        key={document.location.href}
                                    >
                                        <Router
                                            path={':id'}
                                            element={<SubnetApiService />}
                                            key={document.location.href}
                                        />
                                        <Router
                                            path={':id/create'}
                                            element={<CreateSubnetApiService />}
                                            key={document.location.href}
                                        />
                                        <Router
                                            path={'explore'}
                                            element={<ExploreApis />}
                                            key={document.location.href}
                                        />

                                        <Router
                                            path={':id/:subnet_api_service_id'}
                                            element={<EditSubnetApiModal />}
                                            key={document.location.href}
                                        />
                                    </Router>

                                    <Router
                                        path={'billing'}
                                        element={<Billing />}
                                        key={document.location.href}
                                    ></Router>

                                    <Router
                                        path={'browse'}
                                        element={<Browse />}
                                        key={document.location.href}
                                    />
                                    <Router
                                        path={'chat'}
                                        element={<Chat />}
                                        key={document.location.href}
                                    />

                                    <Router
                                        path={'create-new-app'}
                                        element={<CreateNewApp />}
                                        key={document.location.href}
                                    ></Router>

                                    <Router path='api-key' key={document.location.href}>
                                        <Router
                                            index
                                            element={<ApiKeys />}
                                            key={document.location.href}
                                        />
                                    </Router>

                                    <Router path='teams' key={document.location.href}>
                                        <Router
                                            index
                                            element={<InviteUsers />}
                                            key={document.location.href}
                                        />
                                    </Router>

                                    <Router path='manage-teams' key={document.location.href}>
                                        <Router
                                            index
                                            element={<ManageTeams />}
                                            key={document.location.href}
                                        />
                                    </Router>

                                    <Router
                                        path='playground'
                                        key={document.location.href}
                                        element={<PlaygroundPage />}
                                    ></Router>

                                    <Router
                                        path='logs'
                                        key={document.location.href}
                                        element={<Logs />}
                                    ></Router>
                                </>
                            )}
                            <Router path='profile' element={<Profile />} />
                            <Router path='*' element={<MainComponent value={'page not found'} />} />
                        </Router>
                    </>
                    <Router element={<UpdateAppWrapper theme={{ theme, toggleTheme }} />}>
                        <Router path='/update-app' element={<CreateNewApp isEdit />} />
                    </Router>
                    <Router element={<PublicRoute />}>
                        <Router path='/github-login' element={<GithubLogin />} />
                        <Router path='/google-login' element={<GoogleLogin />} />
                        <Router path='/forgot-password' element={<ForgotPassword />} />
                        <Router path='/login' element={<Login />} />
                        <Router path='/verify-email' element={<Login />} />
                        <Router path='/register' element={<Register />} />
                        <Router path='/reset-password' element={<ResetPassword />} />
                        <Router path='/authentication/:id' element={<TwoFAuthentication />} />
                        <Router path='/login/update-password' element={<UpdatePassword />} />
                    </Router>
                </Routes>

                <SuccessPaymentModal />
                <DeleteConfirmationModal />
                <LoginModal />

                <ShowApiKeyModal />
                <CreateApiModal />
                <EditApiModal />
                <SubnetApiDetailsModal />
                <ImagesModal />

                <EmailSentModal />
            </ToastProvider>
        </ThemeProvider>
    )
}

export default Route
